export enum WREX_EMBEDDED_MAP {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k= INSERT KEY HERE
     */
    BUTTON_LABEL = 'WREX_EMBEDDED_MAP.BUTTON_LABEL',
}
